import React from 'react';

import {
    useSelectorProductLicenceIcon, useSelectProductLicences
} from '../../../../../user-profiles';
import {
    useSelectorCurrentProductId,
    useSelectorCurrentProductLicence, useSelectorIsDefaultProduct
} from '../../../../state';
import { LicenceErrorOverlay } from '../licence-error-overlay';
import { licenceErrorMessage } from '../licence-error-overlay/utils/licence-error-overlay-utils';
import { NewLicenceErrorOverlay } from '../new-licence-error-overlay';

export function LicenceOverlayContainer () {
    const currentProductId = useSelectorCurrentProductId();
    const currentProduct = useSelectorCurrentProductLicence();
    const products = useSelectProductLicences();
    const isDefaultProduct = useSelectorIsDefaultProduct();
    const messageText = licenceErrorMessage(isDefaultProduct, currentProduct, products);
    const productIcon = useSelectorProductLicenceIcon(currentProduct?.id);
    const licenseStatus = (products.length > 0 && currentProduct) ? currentProduct.licenseStatus || '' : '';

    if (currentProductId === 1) {
        return <NewLicenceErrorOverlay licenseStatus={licenseStatus} />;
    }

    return (
        <LicenceErrorOverlay
            productIcon={productIcon}
            messageText={messageText}
        />
    );
}
